<template>
    <div class="row">
        <div class="col-md-6" v-for="card in cards" :key="card.field">
            <div class="pra-verdict-card">
                <small class="text-muted text-uppercase">{{ $t(card.label) }}</small>
                <div class="pra-verdict-row m-t-5">
                    <true-false-selector :value="valueOf(card)" :readonly="followsEdits" @select="$emit('change', card.field, $event)" />
                    <small v-if="isOverridden(card)" class="text-muted">{{ modelHint(card) }}</small>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TrueFalseSelector from "./TrueFalseSelector.vue";

export default {
    components: { TrueFalseSelector },
    props: {
        result: { type: Object, required: true },
        // Server-derived verdicts; they follow the parcel edits when ``from_edits`` is set.
        verdicts: { type: Object, default: null },
    },
    data() {
        return {
            cards: [
                { field: "has_access", model: "model_has_access", label: "amas:analysis:pra:legal_verdict" },
                { field: "has_physical_access", model: "model_has_physical_access", label: "amas:analysis:pra:physical_verdict" },
            ],
        };
    },
    computed: {
        followsEdits() { return !!(this.verdicts && this.verdicts.from_edits); },
    },
    methods: {
        valueOf(card) {
            return this.followsEdits ? this.verdicts[card.field] : this.result[card.field];
        },
        isOverridden(card) {
            return this.result[card.model] !== undefined && this.result[card.model] !== this.valueOf(card);
        },
        modelHint(card) {
            const value = this.result[card.model] ? this.$t("general:yes") : this.$t("general:no");
            return this.$t("amas:analysis:pra:model_says:{}").replace("{}", value);
        },
    },
}
</script>

<style>
.pra-verdict-card { border: 1px solid #e3e7ec; border-radius: 4px; padding: 12px 16px; margin-bottom: 25px; }
.pra-verdict-row { display: flex; align-items: center; gap: 8px; }
.pra-verdict-row .label { font-size: 13px; }
.pra-verdict-row .arvio-pra-true-false-selector .btn { padding: 0; }
</style>
